module.exports = __webpack_public_path__ + "img/empty-cart.f9a2c1d3.svg";